import type React from "react"

export const Home: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 20 17"
    fill="none"
    x="1px"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Home</title>
    <path d="M9.5 0.6875C9.78125 0.46875 10.1875 0.46875 10.4688 0.6875L15.5 4.9375V2.25C15.5 1.84375 15.8125 1.5 16.25 1.5C16.6562 1.5 17 1.84375 17 2.25V6.21875L18.7188 7.6875C19.0312 7.96875 19.0625 8.4375 18.8125 8.75C18.5312 9.0625 18.0625 9.09375 17.75 8.84375L17 8.1875V14C17 15.4062 15.875 16.5 14.5 16.5H5.5C4.09375 16.5 3 15.4062 3 14V8.1875L2.21875 8.84375C1.90625 9.09375 1.4375 9.0625 1.15625 8.75C0.90625 8.4375 0.9375 7.96875 1.25 7.6875L9.5 0.6875ZM4.5 6.90625V14C4.5 14.5625 4.9375 15 5.5 15H7V10.25C7 9.5625 7.53125 9 8.25 9H11.75C12.4375 9 13 9.5625 13 10.25V15H14.5C15.0312 15 15.5 14.5625 15.5 14V6.90625L10 2.25L4.5 6.90625ZM8.5 10.5V15H11.5V10.5H8.5Z" />
  </svg>
)
